export const handleSortStraddleData = (
  filteredFyersStraddleHistoryData,
  setFilteredFyersStraddleHistoryData,
  setSortOrder,
  order,
  field
) => {
  console.log(`Sorting based on ${field}`);

  const sortOrder = order === "asc" ? "desc" : "asc";

  const sortedData = [...filteredFyersStraddleHistoryData].sort((a, b) => {
    if (field === "datetime") {
      return order === "asc"
        ? new Date(a.time) - new Date(b.time)
        : new Date(b.time) - new Date(a.time);
    } else if (field === "underlying_scrip_code") {
      return order === "asc"
        ? a[field].localeCompare(b[field])
        : b[field].localeCompare(a[field]);
    } else if (
      ["underlying_ltp", "straddle_ratio", "ce_ltp", "pe_ltp"].includes(field)
    ) {
      return order === "asc" ? a[field] - b[field] : b[field] - a[field];
    } else {
      // Handle other cases if needed
      return 0;
    }
  });
  console.log("Sorted data --->", sortedData);

  setFilteredFyersStraddleHistoryData(sortedData);
  setSortOrder(sortOrder);
};

export const handleSortTradeHistoryData = (
  filteredTradesHistoryData,
  setFilteredTradeHistoryFno,
  setFilteredTradeHistoryEquity,
  setSortOrder,
  order,
  currentState,
  field
) => {
  if (currentState === "equity") {
    const sortOrder = order === "asc" ? "desc" : "asc";

    const sortedData = [...filteredTradesHistoryData].sort((a, b) => {
      if (field === "orderdatetime") {
        return order === "asc"
          ? new Date(a.orderdatetime) - new Date(b.orderdatetime)
          : new Date(b.orderdatetime) - new Date(a.orderdatetime);
      } else if (field === "symbol" || field === "strategy") {
        return order === "asc"
          ? a[field].localeCompare(b[field])
          : b[field].localeCompare(a[field]);
      } else if (["tradedqty", "tradeprice", "side"].includes(field)) {
        return order === "asc" ? a[field] - b[field] : b[field] - a[field];
      } else {
        // Handle other cases if needed
        return 0;
      }
    });
    console.log("Sorted data trade History --->", sortedData);

    setFilteredTradeHistoryEquity(sortedData);
    setSortOrder(sortOrder);
  } else if (currentState === "fno") {
    const sortOrder = order === "asc" ? "desc" : "asc";

    const sortedData = [...filteredTradesHistoryData].sort((a, b) => {
      if (field === "orderdatetime") {
        return order === "asc"
          ? new Date(a.orderdatetime) - new Date(b.orderdatetime)
          : new Date(b.orderdatetime) - new Date(a.orderdatetime);
      } else if (field === "symbol" || field === "strategy") {
        return order === "asc"
          ? a[field].localeCompare(b[field])
          : b[field].localeCompare(a[field]);
      } else if (["tradedqty", "tradeprice", "side"].includes(field)) {
        return order === "asc" ? a[field] - b[field] : b[field] - a[field];
      } else {
        // Handle other cases if needed
        return 0;
      }
    });
    console.log("Sorted data trade History --->", sortedData);

    setFilteredTradeHistoryFno(sortedData);
    setSortOrder(sortOrder);
  }
};

export const handleSortOrderHistoryData = (
  filteredOrdersHistoryData,
  setFilteredOrderHistoryFno,
  setFilteredOrderHistoryEquity,
  setSortOrder,
  order,
  currentState,
  field
) => {
  if (currentState === "equity") {
    const sortOrder = order === "asc" ? "desc" : "asc"

  const sortedData = [...filteredOrdersHistoryData].sort((a, b) => {
      if (field === "orderdatetime") {
        return order === "asc"
          ? new Date(a.orderdatetime) - new Date(b.orderdatetime)
          : new Date(b.orderdatetime) - new Date(a.orderdatetime);
      } else if (field === "symbol" || field === "strategy") {
        return order === "asc"
          ? a[field].localeCompare(b[field])
          : b[field].localeCompare(a[field]);
      } else if (
        [
          "qty",
          "remainingquantity",
          "limitprice",
          "stopprice",
          "status",
          "side",
        ].includes(field)
      ) {
        return order === "asc" ? a[field] - b[field] : b[field] - a[field];
      } else {
        // Handle other cases if needed
        return 0;
      }
    });
    console.log("Sorted data --->", sortedData);

    setFilteredOrderHistoryEquity(sortedData);
    setSortOrder(sortOrder);
  } else if (currentState === "fno") {
    const sortOrder = order === "asc" ? "desc" : "asc";

    const sortedData = [...filteredOrdersHistoryData].sort((a, b) => {
      if (field === "orderdatetime") {
        return order === "asc"
          ? new Date(a.orderdatetime) - new Date(b.orderdatetime)
          : new Date(b.orderdatetime) - new Date(a.orderdatetime);
      } else if (field === "symbol" || field === "strategy") {
        return order === "asc"
          ? a[field].localeCompare(b[field])
          : b[field].localeCompare(a[field]);
      } else if (
        [
          "qty",
          "remainingquantity",
          "limitprice",
          "stopprice",
          "status",
          "side",
        ].includes(field)
      ) {
        return order === "asc" ? a[field] - b[field] : b[field] - a[field];
      } else {
        // Handle other cases if needed
        return 0;
      }
    });
    console.log("Sorted data --->", sortedData);

    setFilteredOrderHistoryFno(sortedData);
    setSortOrder(sortOrder);
  }
};

export const handleSortOpenOrdersData = (
  filteredOpenOrdersData,
  setFilteredOpenOrdersFno,
  setFilteredOpenOrdersEquity,
  setSortOrder,
  order,
  currentState,
  field
) => {
  if (currentState === "EQUITY") {
    const sortOrder = order === "asc" ? "desc" : "asc";

    const sortedData = [...filteredOpenOrdersData].sort((a, b) => {
      if (field === "orderDateTime") {
        return order === "asc"
          ? new Date(a.orderDateTime) - new Date(b.orderDateTime)
          : new Date(b.orderDateTime) - new Date(a.orderDateTime);
      } else if (field === "symbol" || field === "strategy") {
        return order === "asc"
          ? a[field].localeCompare(b[field])
          : b[field].localeCompare(a[field]);
      } else if (
        field === "qty" ||
        field === "remainingQuantity" ||
        field === "limitPrice" ||
        field === "stopPrice" ||
        field === "status" ||
        field === "side"
      ) {
        return order === "asc" ? a[field] - b[field] : b[field] - a[field];
      } else {
        // Handle other cases if needed
        return 0;
      }
    });
    console.log("Sorted data --->", sortedData);

    setFilteredOpenOrdersEquity(sortedData);
    setSortOrder(sortOrder);
  } else if (currentState === "FNO") {
    const sortOrder = order === "asc" ? "desc" : "asc";

    const sortedData = [...filteredOpenOrdersData].sort((a, b) => {
      if (field === "orderDateTime") {
        return order === "asc"
          ? new Date(a.orderDateTime) - new Date(b.orderDateTime)
          : new Date(b.orderDateTime) - new Date(a.orderDateTime);
      } else if (field === "symbol" || field === "strategy") {
        return order === "asc"
          ? a[field].localeCompare(b[field])
          : b[field].localeCompare(a[field]);
      } else if (
        field === "qty" ||
        field === "remainingQuantity" ||
        field === "limitPrice" ||
        field === "stopPrice" ||
        field === "status" ||
        field === "side"
      ) {
        return order === "asc" ? a[field] - b[field] : b[field] - a[field];
      } else {
        // Handle other cases if needed
        return 0;
      }
    });

    setFilteredOpenOrdersFno(sortedData);
    setSortOrder(sortOrder);
  }
};

export const handleSortLivePositionsData = (
  filteredLivePositionsData,
  setFilteredLivePositionsFno,
  setFilteredLivePositionsEquity,
  setSortOrder,
  order,
  currentState,
  field
) => {
  if (currentState === "EQUITY") {
    const sortOrder = order === "asc" ? "desc" : "asc";

    const sortedData = [...filteredLivePositionsData].sort((a, b) => {
      if (field === "symbol") {
        return order === "asc"
          ? a[field].localeCompare(b[field])
          : b[field].localeCompare(a[field]);
      } else if (
        field === "netQty" ||
        field === "netAvg" ||
        field === "ltp" ||
        field === "realized_profit" ||
        field === "unrealized_profit" ||
        field === "pl" ||
        field === "side"
      ) {
        return order === "asc" ? a[field] - b[field] : b[field] - a[field];
      } else {
        // Handle other cases if needed
        return 0;
      }
    });

    setFilteredLivePositionsEquity(sortedData);
    setSortOrder(sortOrder);
  } else if (currentState === "FNO") {
    const sortOrder = order === "asc" ? "desc" : "asc";

    const sortedData = [...filteredLivePositionsData].sort((a, b) => {
      if (field === "symbol" || field === "strategy") {
        return order === "asc"
          ? a[field].localeCompare(b[field])
          : b[field].localeCompare(a[field]);
      } else if (
        field === "netQty" ||
        field === "netAvg" ||
        field === "ltp" ||
        field === "realized_profit" ||
        field === "unrealized_profit" ||
        field === "pl" ||
        field === "side"
      ) {
        return order === "asc" ? a[field] - b[field] : b[field] - a[field];
      } else {
        // Handle other cases if needed
        return 0;
      }
    });

    setFilteredLivePositionsFno(sortedData);
    setSortOrder(sortOrder);
  }
};

export const handleSortClosePositionsData = (
  filteredClosePositionsData,
  setFilteredClosePositionsFno,
  setFilteredClosePositionsEquity,
  setSortOrder,
  order,
  currentState,
  field
) => {
  if (currentState === "EQUITY") {
    const sortOrder = order === "asc" ? "desc" : "asc";

    const sortedData = [...filteredClosePositionsData].sort((a, b) => {
      if (field === "symbol") {
        return order === "asc"
          ? a[field].localeCompare(b[field])
          : b[field].localeCompare(a[field]);
      } else if (
        field === "netQty" ||
        field === "netAvg" ||
        field === "ltp" ||
        field === "realized_profit" ||
        field === "unrealized_profit" ||
        field === "pl" ||
        field === "side"
      ) {
        return order === "asc" ? a[field] - b[field] : b[field] - a[field];
      } else {
        // Handle other cases if needed
        return 0;
      }
    });

    setFilteredClosePositionsEquity(sortedData);
    setSortOrder(sortOrder);
  } else if (currentState === "FNO") {
    const sortOrder = order === "asc" ? "desc" : "asc";

    const sortedData = [...filteredClosePositionsData].sort((a, b) => {
      if (field === "symbol" || field === "strategy") {
        return order === "asc"
          ? a[field].localeCompare(b[field])
          : b[field].localeCompare(a[field]);
      } else if (
        field === "netQty" ||
        field === "netAvg" ||
        field === "ltp" ||
        field === "realized_profit" ||
        field === "unrealized_profit" ||
        field === "pl" ||
        field === "side"
      ) {
        return order === "asc" ? a[field] - b[field] : b[field] - a[field];
      } else {
        // Handle other cases if needed
        return 0;
      }
    });

    setFilteredClosePositionsFno(sortedData);
    setSortOrder(sortOrder);
  }
};

export const handleSortLiveTradesData = (
  filteredLiveTradesData,
  setFilteredLiveTradesFno,
  setFilteredLiveTradesEquity,
  setSortOrder,
  order,
  currentState,
  field
) => {
  if (currentState === "EQUITY") {
    const sortOrder = order === "asc" ? "desc" : "asc";

    const sortedData = [...filteredLiveTradesData].sort((a, b) => {
      if (field === "orderdatetime") {
        return order === "asc"
          ? new Date(a.orderdatetime) - new Date(b.orderdatetime)
          : new Date(b.orderdatetime) - new Date(a.orderdatetime);
      } else if (field === "symbol" || field === "strategy_x") {
        return order === "asc"
          ? a[field].localeCompare(b[field])
          : b[field].localeCompare(a[field]);
      } else if (
        field === "tradedqty" ||
        field === "tradeprice" ||
        field === "side"
      ) {
        return order === "asc" ? a[field] - b[field] : b[field] - a[field];
      } else {
        // Handle other cases if needed
        return 0;
      }
    });

    setFilteredLiveTradesEquity(sortedData);
    setSortOrder(sortOrder);
  } else if (currentState === "FNO") {
    const sortOrder = order === "asc" ? "desc" : "asc";

    const sortedData = [...filteredLiveTradesData].sort((a, b) => {
      if (field === "orderdatetime") {
        return order === "asc"
          ? new Date(a.orderdatetime) - new Date(b.orderdatetime)
          : new Date(b.orderdatetime) - new Date(a.orderdatetime);
      } else if (field === "symbol" || field === "strategy_x") {
        return order === "asc"
          ? a[field].localeCompare(b[field])
          : b[field].localeCompare(a[field]);
      } else if (
        field === "tradedqty" ||
        field === "tradeprice" ||
        field === "side"
      ) {
        return order === "asc" ? a[field] - b[field] : b[field] - a[field];
      } else {
        // Handle other cases if needed
        return 0;
      }
    });

    setFilteredLiveTradesFno(sortedData);
    setSortOrder(sortOrder);
  }
};
